import { gql } from "@apollo/client";

export const FAV_COINS = gql`
  query FavCoins {
    favCoins
  }
`

export const ADD_FAV_COIN = gql`
	mutation AddFavCoin($coin: String!) {
		addFavCoin(coin: $coin)
	}
`;

export const REMOVE_FAV_COIN = gql`
	mutation RemoveFavCoin($coin: String!) {
		removeFavCoin(coin: $coin)
	}
`;
